import { useContext } from 'react'
import {
  ChatbotContext,
  IChatbotContext,
} from '@components/site/providers/ChatbotProvider'

export default function useChatbot(): IChatbotContext {
  return useContext(ChatbotContext)
}
